import { Dropdown, Menu, MenuButton, MenuItem } from '@mui/joy';
import DirectionsRoundedIcon from '@mui/icons-material/DirectionsRounded';
import { mapRoutes } from '../utils/mapRoutes';
export default function RouteMenu({ deal }) {
  const routes = mapRoutes(deal);
  return <Dropdown><MenuButton size="sm" variant="soft" color="neutral" disabled={!routes.length}
    startDecorator={<DirectionsRoundedIcon sx={{ fontSize: 17 }} />} sx={{ borderRadius: '10px', minHeight: 36 }} onClick={e => e.stopPropagation()}>Маршрут</MenuButton>
    <Menu placement="bottom-end" sx={{ zIndex: 10310 }}>{routes.map(route => <MenuItem key={route.title} component="a" href={route.url} target="_blank" rel="noopener noreferrer" onClick={e => e.stopPropagation()}>{route.title}</MenuItem>)}</Menu>
  </Dropdown>;
}
